import React, { useState } from 'react';
import OriginMethods from './OriginMethods';
import DestinationMethods from './DestinationMethods';
import { ArrowUpRight, ArrowDownLeft } from 'lucide-react';

const PaymentMethods = () => {
  const [tab, setTab] = useState('origin');

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-slate-800">Gestión de Pagos</h2>
        <div className="flex bg-white p-1 rounded-xl shadow-sm border">
          <button 
            onClick={() => setTab('origin')}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${tab === 'origin' ? 'bg-blue-600 text-white shadow-md' : 'text-slate-500 hover:bg-slate-50'}`}
          >
            <ArrowUpRight className="w-4 h-4" /> Origen
          </button>
          <button 
            onClick={() => setTab('destination')}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${tab === 'destination' ? 'bg-blue-600 text-white shadow-md' : 'text-slate-500 hover:bg-slate-50'}`}
          >
            <ArrowDownLeft className="w-4 h-4" /> Destino
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border min-h-[500px]">
        {tab === 'origin' ? <OriginMethods /> : <DestinationMethods />}
      </div>
    </div>
  );
};

export default PaymentMethods;